import useEstudiantesList from "./useEstudiantesList";
import useEstudianteForm from "./useEstudianteForm";
import useDocumentosEstudiante from "./useDocumentosEstudiante";
import useHistorialAcademico from "./useHistorialAcademico";

export default function useEstudiantesLogic() {
  const list = useEstudiantesList();

  const form = useEstudianteForm({
    onCreated: (nuevo) => list.upsertEstudiante(nuevo),
    onUpdated: (actualizado) => {
      list.upsertEstudiante(actualizado);
      if (list.seleccionado?.id === actualizado.id) list.setSeleccionado(actualizado);
    },
    onDeleted: (borrado) => {
      list.removeEstudiante(borrado.id);
      if (list.seleccionado?.id === borrado.id) list.setSeleccionado(null);
    },
  });

  const documentos = useDocumentosEstudiante(list.seleccionado?.id);
  const historial = useHistorialAcademico(list.seleccionado?.id);

  return {
    ...list,
    form,
    documentos,
    historial,
  };
}
